<app-navbar></app-navbar>
<ng-snotify></ng-snotify>
<div class="container-fluid">
    <router-outlet></router-outlet>
</div>